module.exports = __webpack_public_path__ + "static/media/relation1.66312b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/relation1.jpg
// module id = 457
// module chunks = 0